import React from 'react'
import { Switch, Route } from 'react-router-dom'
import ContentArea from '../../organisms/content-area/ContentArea'
import AccountSettings from './AccountSettings'
import Contributors from './Contributors'

const Settings = () => (
  <div>
    <ContentArea>
      <Switch>
        <Route exact path="/settings" component={AccountSettings}/>
        <Route path="/settings/account" component={AccountSettings}/>
        <Route path="/settings/contributors" component={Contributors}/>
      </Switch>
    </ContentArea>
  </div>
)

export default Settings
